import React from 'react';
import Search from '../../../../assets/file.svg';

const PreviewEmpty = () => {
  return (
    <div
      className="self-stretch px-3 py-8 bg-[#E2E8F050] rounded-lg inline-flex flex-col justify-start items-center gap-3">
      <div className="w-8 h-8 relative overflow-hidden">
        <img
          src={Search}
          alt="File Icon"
          className="w-8 h-8"
        />
      </div>
      <div className="flex flex-col justify-start gap-3 items-center">
        <div className="justify-start text-[#141A1F] text-base font-semibold leading-5">No
          hay elementos a previsualización
        </div>
        <div className="w-72 justify-start text-slate-600 text-sm font-normal leading-4">Selecciona
          un proveedor de servicio para cargar detalles
        </div>
      </div>
    </div>
  );
};

export default PreviewEmpty;
